/**
 * HomePageBackground — poză de fundal fixă, cu overlay foarte subtil.
 *
 * SE FOLOSEȘTE DOAR PE HomePage și GatedScreen.
 * NU se mai randează global în AppShell, ca să nu apară în spatele
 * pozelor din /gallery, /masonry, /feed etc. (acolo fundalul trebuie
 * să fie opac, altfel pozele par "transparente").
 *
 * Imagine: opacity 0.40 (vizibilă, dar nu agresivă)
 * Overlay: gradient foarte ușor (max 0.20) pentru contrast minim în zonele cu text
 *
 * Containerul e fixed + z-0, deci stă în spatele oricărui conținut.
 * Fără pointer-events, deci nu interferează cu click-urile.
 */

const BACKGROUND_IMG = '/larisa%20si%20dani.jpg';

export function HomePageBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      {/* Imaginea de fundal — vizibilă dar discretă */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url("${BACKGROUND_IMG}")`,
          opacity: 0.40,
        }}
      />
      {/* Overlay foarte subtil — doar zonei cu text ii adaugam un strop de contrast */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.02) 40%, rgba(255,255,255,0.15) 100%)',
        }}
      />
    </div>
  );
}
